import axios from 'axios';
import { requestFunnel, simulatorBackend } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

const prospectsRoute = 'prospects';

export const getProspectList = async (body = {}, cancelExecutor = () => { }) => {
  const cancelToken = new axios.CancelToken(cancelExecutor);
  const options = getOptions();
  options.cancelToken = cancelToken;
  const { data } = await simulatorBackend.post(prospectsRoute, body, options);
  return data;
};

export const getProspectListCSV = async (body = {}, cancelExecutor = () => { }) => {
  const cancelToken = new axios.CancelToken(cancelExecutor);
  const options = getOptions();
  options.cancelToken = cancelToken;
  const { data } = await simulatorBackend.post(`${prospectsRoute}/report`, body, options);
  return data;
};

export const getProspectById = async prospectId => {
  const { data } = await simulatorBackend.get(`${prospectsRoute}/${prospectId}`, getOptions());
  return data;
};

export const getProspectBySearchParam = async searchString => {
  const options = getOptions();
  options.params = { search: searchString };
  const { data } = await simulatorBackend.get(`${prospectsRoute}/search`, options);
  return data;
};

export const setCommercialAnalyst = async body => {
  const { data } = await simulatorBackend.patch(`${prospectsRoute}/set-commercial-analyst`, body, getOptions());
  return data;
};

export const unsetCommercialAnalyst = async body => {
  const { data } = await simulatorBackend.patch(`${prospectsRoute}/unset-commercial-analyst`, body, getOptions());
  return data;
};

export const getAnalystsLists = async () => {
  const { data } = await requestFunnel.get('user/analysts', getOptions());
  return data;
};

export const addInteractions = async (prospectId, body) => {
  const { data } = await simulatorBackend.patch(`${prospectsRoute}/add-interactions/${prospectId}`, body, getOptions());
  return data;
};

export const getProspectStatusList = async () => {
  const { data } = await simulatorBackend.get(`${prospectsRoute}/status`, getOptions());
  return data;
};

export const sendEmailProspectRetoken = async email => {
  try {
    const sendEmailReTokenParams = { params: { email } };
    const { data } = await requestFunnel.get('auth/send-email-retoken', sendEmailReTokenParams, getOptions());
    return data;
  } catch (_error) {
    return false;
  }
};

export const addProspectDocument = async (prospectId, body) => {
  const { data } = await simulatorBackend.patch(`${prospectsRoute}/add-document/${prospectId}`, body);
  // , getOptions()
  return data;
};
export const addCodebtorDocument = async (prospectId, body) => {
  const { data } = await simulatorBackend.patch(`${prospectsRoute}/add-codebtor-document/${prospectId}`, body);
  // , getOptions()
  return data;
};

export const sendNotification = async body => {
  const { data } = await requestFunnel.post(`${prospectsRoute}/send-notification`, body);
  return data;
};

export const getProspectDocument = async documentId => {
  const options = getOptions();
  const { data } = await simulatorBackend.get(`${prospectsRoute}/get-document/${documentId}`, options);
  return data.getProspectSignedUrlResponse.signedUrl;
};
